<template>
	<div class="employee-card">
		<div class="employee-info">
			<b-avatar class="employee-image" variant="secondary" :text="initials"></b-avatar>

			<div class="info-details">
				<span class="fullName">{{ fullName }}</span>
				<span class="hours">{{ workedHours }}/{{ weeklyHours }} hours assigned</span>
				<div class="tags">
					<tag
						v-for="tag in tagListApi"
						:key="`tag-${tag.id}`"
						:id="tag.id"
						:color="tag.color"
						:title="tag.title"
					></tag>
				</div>
			</div>
		</div>
		<button>+ Shift</button>
	</div>
</template>

<script>
import tag from '@/components/tag';
import { tagList } from '../../api';
export default {
	name: 'employee',
	components: { tag },
	props: {
		id: { required: false, type: Number },
		fullName: { required: false, type: String },
		// the total amount of hours that someone worked in current week
		workedHours: { required: false, type: String, default: () => '-' },
		// the total amount of hours that someone can work in one week
		weeklyHours: { required: false, type: Number, default: 40 },
		// the list of tags of why the system choose this employee
		tagList: { required: false, type: Array },
		initials: { required: false, type: String },

		index: { required: false, type: Number },
	},
	data() {
		return {
			tagListApi: [...tagList],
		};
	},
	mounted() {
		this.tagListApi = this.tagList.map(tagId => {
			return tagList.find(tag => tag.id === tagId);
		});
	},
};
</script>

<style lang="scss" scoped>
.employee-card {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 300px;
	max-height: 70px;
	padding: 7px 10px;
	border-radius: 3px;
	box-shadow: 0 0 10px 0 #e3e3e3;
	background-color: #ffffff;

	.employee-image {
		width: 3rem !important;
		height: 3rem !important;
		font-size: 1.3em !important;
		background-color: #e0e0e0 !important;
		color: #616e84 !important;
	}

	button {
		width: 45px;
		height: 22px;
		border-radius: 3px;
		background-color: #517fa8;
		font-size: 9px;
		text-align: center;
		color: #ffffff;
	}

	.employee-info {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-self: space-between;

		img {
			width: 38px;
			height: 38px;
			border-radius: 50%;
			object-fit: contain;
		}
		.info-details {
			display: flex;
			flex-direction: column;
			align-items: center;
			align-items: flex-start;
			margin-left: 10px;

			.fullName {
				font-size: 13px;
			}
			.hours {
				font-size: 11px;
			}

			.tags {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				margin-top: 5px;
			}
		}
	}
}
</style>
